import type { ReactElement } from 'react';
import { Box, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import { SurfaceCard } from '@/design/SurfaceCard';

const PAGE_TITLES: Record<string, { title: string; description: string }> = {
    organization: {
        title: 'Organization',
        description: 'Company profile, deployment region, and instance metadata.',
    },
    'identity-providers': {
        title: 'Identity Providers',
        description: 'SSO, SAML 2.0, and OIDC configuration.',
    },
    'access-control': {
        title: 'Access Control',
        description: 'Roles, permissions, and MFA enforcement.',
    },
    providers: {
        title: 'AI Providers',
        description: 'AI vendor connections and sync configuration.',
    },
    'data-retention': {
        title: 'Data & Retention',
        description: 'Retention policies, data residency, and compliance settings.',
    },
    notifications: {
        title: 'Notifications',
        description: 'Alert thresholds and delivery preferences.',
    },
    api: {
        title: 'API',
        description: 'API keys, webhook endpoints, and external integrations.',
    },
};

export default function SettingsPlaceholderPage(): ReactElement {
    const { section } = useParams<{ section: string }>();
    const info = PAGE_TITLES[section ?? ''];

    return (
        <Box>
            <PageHeaderComponent title={info?.title ?? section ?? 'Unknown'} subtitle={info?.description ?? 'This section is under construction.'} />
            <SurfaceCard $padding="lg" $static>
                <Box
                    p="xl"
                    style={{
                        border: '1px dashed var(--bm-color-border)',
                        borderRadius: 'var(--bm-radius)',
                        textAlign: 'center',
                    }}
                >
                    <Text size="sm" c="dimmed" ff="monospace" fw={600}>
                        Coming soon
                    </Text>
                </Box>
            </SurfaceCard>
        </Box>
    );
}
